import { styled } from "styled-components";

import SwPageContent from "app/components/page-content";

export const RankTrackerPageContentWrapper = styled(SwPageContent)`
    .sw-layout-page {
        max-width: 1600px;
    }
`;
